import React from "react";
class Introduction extends React.Component {


    render() {

        return (
          <section className={`rob-intro rob-intro--${this.props.direction['value']}`}>

              <div className="container">
                  <div className="row">
                      <div className={ this.props.direction['value'] === 'left' ? "col-xl-6 rob-intro__col-quote" : "col-xl-6 rob-intro__col-quote"}>
                          <div className="rob-intro__quote">{this.props.quote}</div>
                      </div>
                      <div className={ this.props.direction['value'] === 'left' ? "col-xl-6" : "col-xl-6"}>
                          <div className="rob-intro__introduction">
                              <div  dangerouslySetInnerHTML={{__html: this.props.paragraph}}  >
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        )
    }

}

export default Introduction;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/Introduction.js